// // frontend/src/components/AdminLayout/index.tsx
import { useState } from "react";
import styles from "./AdminLayout.module.css";
import EnquiriesComponent from "../admin/enquiry/EnquiriesComponent";
import SeriesComponent from "../admin/series/SeriesComponent";
import ProductsComponent from "../admin/product/ProductsComponent";
import UserAdminPage from "../admin-pannel/admin-user";
import { logout } from "../../service/auth";
import { useNavigate } from "react-router-dom";

const AdminLayout = () => {
  const [activeTab, setActiveTab] = useState<
    "enquiries" | "series" | "products" | "users"
  >("enquiries");
  const navigate = useNavigate();
  return (
    <div className={styles.adminContainer}>
      {/* Header */}
      <div className={styles.headerContainer}>
        <div className={styles.logo}>
          <img
            src="/images/scadellogosvg.png"
            alt="scadelLogo"
            onClick={() => navigate("/")}
          />
        </div>
        <button className={styles.logoutButton} onClick={logout}>
          Logout
        </button>
      </div>

      <div className={styles.mainLayout}>
        <aside className={styles.sidebar}>
          {/* Navigation */}
          <nav className={styles.nav}>
            <button
              className={`${styles.navButton} ${
                activeTab === "enquiries" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("enquiries")}
            >
              Enquiries
            </button>
            <button
              className={`${styles.navButton} ${
                activeTab === "series" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("series")}
            >
              Series
            </button>
            <button
              className={`${styles.navButton} ${
                activeTab === "products" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("products")}
            >
              Products
            </button>
            <button
              className={`${styles.navButton} ${
                activeTab === "users" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("users")}
            >
              Users
            </button>
          </nav>
        </aside>

        {/* Main Content */}
        <main className={styles.mainContent}>
          <header className={styles.header}>
            <div className={styles.headerLeft}>
              <h2 className={styles.pageTitle}>
                {activeTab === "enquiries" && "Enquiries"}
                {activeTab === "series" && "Series Management"}
                {activeTab === "products" && "Products Management"}
                {activeTab === "users" && "Users Management"}
              </h2>
            </div>
          </header>

          <div className={styles.contentArea}>
            {activeTab === "enquiries" && <EnquiriesComponent />}
            {activeTab === "series" && <SeriesComponent />}
            {activeTab === "products" && <ProductsComponent />}
            {activeTab === "users" && <UserAdminPage />}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
